import styled from "styled-components";
import { media } from "@nested/nested-react-components";

const Image = styled.img`
  width: 100%;
  margin: calc(${({ theme }) => theme.padding.base} * 2) 0;
  max-width: ${({ theme }) => theme.font.typographyBreakpoint};

  ${media.md`
    width: ${({ theme }) => theme.font.typographyBreakpoint};
    margin-left: auto;
    margin-right: auto;
  `};
`;

export { Image };
